define(function(require, exports, module) {
    
    return function(avalon) {

        var tpl = [
            '<div class="dialog-blank" ms-on-tap="bgClick" ms-visible="isShowingDialog">',
                '<div class="dialog-blank-content" ms-on-tap="contentClick" ms-attr-style="cssLabel">',
                    '<div>[[content | html]]</div>',
                '</div>',
            '</div>'
        ].join('');

        avalon.component('ms:dialog', {
            $template: tpl,
            // $replace: 1, //是否替换容器
            content: '',
            css: {},
            cssLabel: '',
            isShowingDialog: false,
            $ready: function(vm, elem, vms) {
                var csss = [];
                for(var i in vm.css) {
                    if(vm.css.hasOwnProperty(i)) {
                        csss.push(i + ':' + vm.css[i]);
                    }
                }
                vm.cssLabel = csss.join(';');

                vm.bgClick = function() {
                    vm['hiddenCallback'] && vm['hiddenCallback']();
                    vm.isShowingDialog = false;
                };

                vm.contentClick = function($event) {
                    $event.stopPropagation();
                };

                vm.$watch('isShowingDialog', function(v) {
                    var content = elem.querySelector('[slot]');
                    if(v) {
                        content.style.display = 'block';
                    } else {
                        content.style.display ='none';
                    }
                });

                vm.onInit(vm);

                // 这里加上补充style的原因是app里渲染不出 ms-attr-style="cssLabel" 下来再研究
                setTimeout(function() {
                    if(vm.cssLabel) {
                        var dialogContent = $('.dialog-blank-content');
                        if(dialogContent.length) {
                            var style = dialogContent.attr('stype');
                            if(!style) {
                                dialogContent.attr('style', vm.cssLabel);
                            }
                        }
                    }
                }, 500);
            },
            bgClick: avalon.noop,
            contentClick: avalon.noop,
            onInit: avalon.noop
        });
    }
});


// WEBPACK FOOTER //
// ./modules/dialog/0.0.0/dialog.blank.js